import { observer } from 'mobx-react-lite';

import Frame from '@client/uikit/Frame';
import Box from '@client/uikit/Box';
import { MarkdownViewer } from '@client/component/editor/MarkdownViewer';
import { CommonLink } from '@client/component/CommonLink';

const ReadabilityTestPage = observer(() => {
    return (
        <Frame>
            <Frame.Title title="가독성 테스트" />
            <Box>
                <Box.Title title="참고 문서" />
                <div className="text-base">
                    <CommonLink to="https://brunch.co.kr/@chulhochoiucj0/34" className="link">
                        가독성
                    </CommonLink>
                </div>
            </Box>
            <Box>
                <Box.Title title="기본 텍스트 (text-base)" />
                <div className="text-base">
                    <h1 className="mb-4.5">이건 그냥 H1 제목</h1>
                    <h2 className="mb-4">이건 그냥 H2 제목</h2>
                    <h3 className="mb-3.5">이건 그냥 H3 제목</h3>
                    <p>
                        안드로이드의 기본 본문용 글꼴의 크기는 16dp이고, iOS는 17pt이다. 모바일
                        환경에서는 17px 크기가 이상적이며, 20px보다 크면 가독성이 떨어진다. 네이버의
                        뉴스 본문과 블로그 앱 미디엄의 본문 크기는 18px이다. 18.5px부터는 가독성이
                        떨어지기 시작한다. 모바일에서 본문의 크기는 16~19px 범위가 가독성을
                        보장한다.
                    </p>
                </div>
            </Box>
            <Box>
                <Box.Title title="마크다운 뷰어 기본값" />
                <MarkdownViewer
                    markdown={`
# 가독성을 위한 텍스트 크기
## 제목은 글자 간격이 좁아야 가독성이 높다
### 실제 가장 많이 사용할 제목
안드로이드의 기본 본문용 글꼴의 크기는 16dp이고, iOS는 17pt이다. 모바일 환경에서는 17px 크기가 이상적이며, 20px보다 크면 가독성이 떨어진다. 네이버의 뉴스 본문과 블로그 앱 미디엄의 본문 크기는 18px이다. 18.5px부터는 가독성이 떨어지기 시작한다. 모바일에서 본문의 크기는 16~19px 범위가 가독성을 보장한다.

동일한 내용이지만 오른쪽의 예가 더 읽기 편하다. 단락 Paragraph은 문단이라고도 한다. 콘텐츠를 빠르게 훑어보고, 단락 정보를 쉽게 파악하고 이해할 수 있도록 긴 글을 소주제별 내용이나 형식에 따라 구분하여 단락 간격 Paragraph spacing을 준다.

단락 간의 간격은 본문 글꼴 크기의 75%가 적정하다. 문단의 글꼴 크기가 16px라면 단락의 간격은 12px을 줄 수 있다. 17px 이라면 **12.75px** 정도가 적정하다는 뜻이다.

- 목록 1번. 나는 목록의 내용이다.
- 목록 2번. 나는 목록의 내용이다. 나는 목록의 내용이다. 2줄이 될 수도 있다.
- 목록 3번으로 마무리하자.

다시 본문이 나온다.
그리고 숫자 목록도 있다.

1. 나는 목록의 내용이다.
2. 나는 목록의 내용이다. 나는 목록의 내용이다. 2줄이 될 수도 있다.
3. 목록 3번으로 마무리하자.

다시 본문이 나온다.

### 제목 밑에 본문
다시 본문이 나온다.
그리고 숫자 목록도 있다.

### 제목 밑에 목록
- 다시 본문이 나온다.
- 그리고 숫자 목록도 있다.


                    `}
                />
            </Box>
        </Frame>
    );
});

export default ReadabilityTestPage;
